import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$f = ".Logo_module_container__f17fe7db{align-items:center;display:flex;gap:var(--st-spacing-2);justify-content:center}.Logo_module_logo__f17fe7db{max-height:50px;max-width:100px}";
collectCss(css$f);
var modules_2ccbe80d = {"container":"Logo_module_container__f17fe7db","logo":"Logo_module_logo__f17fe7db"};

export { css$f as css, modules_2ccbe80d as default };
//# sourceMappingURL=Logo.module.css.mjs.map
